<section class="hero-image" aria-label="Restaurant hero section">
  <div class="hero-gallery" aria-hidden="true">
    @for (highlight of config.highlights; track highlight; let index = $index) {
      <img
        class="hero-slide"
        [src]="'assets/images/cover/' + highlight"
        [style.--slide-index]="index"
        alt=""
        [attr.fetchpriority]="index === 0 ? 'high' : null"
        [loading]="index === 0 ? 'eager' : 'lazy'"
        decoding="async" />
    }
  </div>

  <div class="hero-overlay" aria-hidden="true"></div>

  <div class="page-content hero-content">
    <p class="hero-welcome">{{ 'welcome' | translate }}</p>

    <button type="button" class="menu-cta" (click)="onClick()">
      <span class="menu-span">{{ 'nav.menu' | translate }}</span>
      <i class="bi bi-chevron-double-right" aria-hidden="true"></i>
    </button>
  </div>
</section>
